import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function hideOrderTrackingDetailsDialog(): RootActionTypes {
  return standardAction(ActionTypes.HIDE_ORDER_TRACKING_DETAIL_DIALOG);
}
